export class Forbidden extends Error {
  data?: any;

  constructor(data?: any) {
    super('	Not have permission to do this action');
    this.name = 'Not have permission to do this action';
    this.data = data;
  }
}
